module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.customClass
  }, [_c('div', {
    staticClass: "cb-cart",
    class: {
      'cb-cart--multiple': _vm.isMultipleCart
    }
  }, [_c('cb-slide-n-fade', {
    attrs: {
      "is-list": true,
      "timeOut": true,
      "reCalculateMargin": true
    }
  }, _vm._l((_vm.order_cart_items), function(item) {
    return (_vm.loaded(item)) ? _c('line-item', {
      key: item.id,
      attrs: {
        "readonly": _vm.readonly,
        "singleCart": !_vm.isMultipleCart,
        "item": item,
        "singleItem": _vm.isSingleItem,
        "currencyCode": _vm.currency_code
      }
    }) : _vm._e()
  })), _vm._v(" "), _vm._t("addons")], 2), _vm._v(" "), (_vm.isMultipleCart) ? _c('div', {
    staticClass: "cb-cart cb-cart--multiple cb-cart--footer"
  }, [(_vm.is_discount_present) ? _c('div', {
    staticClass: "cb-item--extras cb-transition__fade"
  }, [_c('div', {
    staticClass: "cb-item__name"
  }, [_vm._v(_vm._s(_vm.consolidated_discount.title) + "\n          "), (_vm.coupon_enabled && _vm.consolidated_discount.coupon_id && !_vm.readonly) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    staticClass: "cb-item__action cb-extras__action",
    on: {
      "click": function($event) {
        _vm.removeDiscount(_vm.consolidated_discount.coupon_id)
      }
    }
  }, [_vm._v(_vm._s(_vm.ct('cart.remove')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cb-item__deduction"
  }, [_vm._v(_vm._s(_vm._f("cbCurrency")(_vm.consolidated_discount.amount, _vm.currency_code, true)))])]) : _vm._e(), _vm._v(" "), (_vm.total_credits > 0) ? _c('div', {
    staticClass: "cb-item--extras"
  }, [_c('div', {
    staticClass: "cb-item__name"
  }, [_vm._v(_vm._s(_vm.ct('credits_applied.label')))]), _vm._v(" "), _c('div', {
    staticClass: "cb-item__deduction"
  }, [_vm._v(_vm._s(_vm._f("cbCurrency")(_vm.total_credits, _vm.currency_code, true)))])]) : _vm._e(), _vm._v(" "), (_vm.consolidated_tax && _vm.is_tax_exclusive) ? _c('div', {
    staticClass: "cb-item--extras"
  }, [_c('div', {
    staticClass: "cb-item__name"
  }, [_vm._v(_vm._s(_vm.consolidated_tax.title))]), _vm._v(" "), _c('div', {
    staticClass: "cb-item__deduction"
  }, [_vm._v(_vm._s(_vm._f("cbCurrency")(_vm.consolidated_tax.amount, _vm.currency_code)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cb-item__total"
  }, [_vm._v("\n      " + _vm._s(_vm._f("cbCurrency")((_vm.amount_due || 0), _vm.currency_code)) + "\n      ")]), _vm._v(" "), (_vm.consolidated_tax && _vm.is_tax_inclusive) ? _c('div', {
    staticClass: "cb-item"
  }, [_c('div', {
    staticClass: "cb-item__name"
  }, [_vm._v(_vm._s(_vm.cmt('included_tax_group.txt')) + " " + _vm._s(_vm.consolidated_tax.title) + " : " + _vm._s(_vm._f("cbCurrency")(_vm.consolidated_tax.amount, _vm.currency_code)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.coupon_enabled && !_vm.is_discount_present && !_vm.readonly) ? [_c('cb-discount')] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b59a6e62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/CartCommon.vue
// module id = 384
// module chunks = 34 66